import styled from 'styled-components';

export const StyledTitleSection = styled.section`
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin: 0 15px 50px 15px;
    background-image: image-set(
        url('assets/titleSectionBg-2x.webp') 1x type('image/webp'),
        url('assets/titleSectionBg-2x.jpg') 1x type('image/jpg'),
        url('assets/titleSectionBg-2x.webp') 2x type('image/webp'),
        url('assets/titleSectionBg-2x.jpg') 2x type('image/jpg'),
        url('assets/titleSectionBg-3x.webp') 3x type('image/webp'),
        url('assets/titleSectionBg-3x.jpg') 3x type('image/jpg')
    );
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border: none;
    border-radius: 30px;

    & p {
        font-weight: 500;
    }

    @media screen and (min-width: 577px) {
        flex-direction: row;
        width: 100%;
        max-width: 1340px;
        margin: 0 0 80px 0;
    }
`;

export const StyledContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 17px 0px 17px;
    text-align: center;

    background-image: image-set(
        url('assets/mobile-index-2x.webp') 1x type('image/webp'),
        url('assets/mobile-index-2x.png') 1x type('image/png'),
        url('assets/mobile-index-2x.webp') 2x type('image/webp'),
        url('assets/mobile-index-2x.png') 2x type('image/png'),
        url('assets/mobile-index-3x.webp') 3x type('image/webp'),
        url('assets/mobile-index-3x.png') 3x type('image/png')
    );
    background-repeat: no-repeat;
    background-size: auto 75%;
    background-position: bottom center;

    & h1 {
        margin-bottom: 10px;
        & span {
            display: none;
        }
    }

    & a {
        margin-top: 389px;
        margin-bottom: 20px;
        padding: 15px;
    }

    @media screen and (min-width: 577px) {
        align-items: flex-start;
        padding: 50px 37% 50px 50px;
        text-align: left;
        background-image: image-set(
            url('assets/desktop-index-2x.webp') 1x type('image/webp'),
            url('assets/desktop-index-2x.png') 1x type('image/png'),
            url('assets/desktop-index-2x.webp') 2x type('image/webp'),
            url('assets/desktop-index-2x.png') 2x type('image/png'),
            url('assets/desktop-index-3x.webp') 3x type('image/webp'),
            url('assets/desktop-index-3x.png') 3x type('image/png')
        );
        background-repeat: no-repeat;
        background-position: right;
        background-size: 37%;
        & h1 {
            margin-top: 170px;
            margin-bottom: 20px;
            & span {
                display: inline;
            }
        }

        & p {
            max-width: 70%;
        }

        & a {
            margin: 30px 0 0 0;
        }
    }
`;
